import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Icons, Tooltip } from '@nextiva/next-ui-components';

import {
  getHiddenDigitsForPayment,
  getPaymentDetails,
  getPaymentIcon,
} from 'getters/paymentGetters/paymentGetters';
import {
  SimpleParagraph,
  StyledContainer,
  StyledImg,
  StyledParagraph,
  StyledWalletImg,
} from './PaymentMethodInfo.styled';
import { getCreditCardTypeIcon } from 'getters/creditCardGetters/creditCardGetters';
import { APPLE_PAY_EXPIRATION_TOOLTIP } from 'constant/applePayConstants';

/**
 * PaymentMethodInfo component.
 *
 * @property {boolean} [isDrawerPage] - Indicates if the component is rendered within the Payment Drawer (optional, default false).
 * @property paymentMethod - The payment method object containing info to display.
 */
const PaymentMethodInfo = ({ isDrawerPage, paymentMethod }) => {
  const { wallet } = paymentMethod;

  /**
   * Flag to determine if the wallet card icon should be displayed.
   */
  const displayWalletCardIcon = wallet?.walletType === 'APPLE_PAY';

  /**
   * Flag to determine if the wallet-tooltip should be displayed.
   */
  const displayTooltip = !isDrawerPage && displayWalletCardIcon;

  return (
    <StyledContainer data-testid="BillingLicensing-PaymentMethodInfo">
      <StyledImg
        alt="card-icon"
        data-testid="BillingLicensing-PaymentMethodInfo-PaymentIcon"
        src={getPaymentIcon(paymentMethod)}
      />
      <div>
        <SimpleParagraph data-testid="BillingLicensing-PaymentMethodInfo-HiddenDigits">
          {getHiddenDigitsForPayment(paymentMethod)}
        </SimpleParagraph>
        <StyledParagraph data-testid="BillingLicensing-PaymentMethodInfo-Details">
          {displayWalletCardIcon && (
            <StyledWalletImg
              alt="wallet-card-icon"
              data-testid="BillingLicensing-PaymentMethodInfo-WalletIcon"
              src={getCreditCardTypeIcon(wallet?.cardType)}
            />
          )}
          {getPaymentDetails(paymentMethod)}
          {displayTooltip && (
            <Tooltip
              data-testid="BillingLicensing-PaymentMethodInfo-WalletTooltip"
              title={APPLE_PAY_EXPIRATION_TOOLTIP}
            >
              <Icon icon={Icons.info} />
            </Tooltip>
          )}
        </StyledParagraph>
      </div>
    </StyledContainer>
  );
};

PaymentMethodInfo.defaultProps = {
  isDrawerPage: false,
};

PaymentMethodInfo.propTypes = {
  isDrawerPage: PropTypes.bool,
  paymentMethod: PropTypes.object.isRequired,
};

export default PaymentMethodInfo;
